import { IMAGECROPPER_LOAD, IMAGECROPPER_UNLOAD, IMAGECROPPER_SET } from '../../actionDefinitions';
import { createReducer } from '../../reducerUtils';
import moment from 'moment';

const initialState = {
    error: undefined,
    notification: { message: '', status: '' }
};

const handlers = {
    [IMAGECROPPER_LOAD]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return action.payload;
    },
    [IMAGECROPPER_UNLOAD]: () => initialState,
    [IMAGECROPPER_SET]: (state, action) => action
};

export default createReducer(initialState, handlers);
